import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import SendIcon from "@material-ui/icons/Send";

const useStyles = makeStyles((theme) => ({
  emailList: {
    width: "100%",
    marginTop: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ccc",
    borderRadius: 4,
    maxHeight: 150,
    overflow: "auto",
  },

  listItem: {
    borderBottom: "1px solid #eee",
    paddingTop: 4,
    paddingBottom: 4,
    minHeight: "32px", // Reduce the minimum height
  },
  listItemText: {
    margin: 0, // Remove extra margin around the ListItemText
    "& .MuiTypography-root": {
      fontSize: "0.85rem", // Slightly smaller text
    },
  },
  iconButton: {
    padding: 3, // Make the delete button smaller
  },
}));

const EmailTextFeildMultiple = ({ emails, setEmails, handleSendMail,inputValue, setInputValue }) => {
  const classes = useStyles();
  // const [inputValue, setInputValue] = useState("");
  const [error, setError] = useState(false);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      const email = inputValue.trim();

      if (email && emailRegex.test(email)) {
        if (!emails.includes(email)) {
          setEmails([...emails, email]);
        }
        setInputValue("");
        setError(false);
      } else if (email) {
        setError(true);
      }
    }
  };

  const handleChange = (event) => {
    setInputValue(event.target.value);
    if (error) setError(false);
  };

  const handleDelete = (emailToDelete) => {
    setEmails(emails.filter((email) => email !== emailToDelete));
  };

  // useEffect(() => {
  //   console.log("emails::", emails);
  //   console.log("inputValue::", inputValue);
  // }, [inputValue, emails]);

  const isEmail = emails?.length > 0;

  return (
    <div style={{ marginTop: "1em" }}>
      <div style={{ display: "flex", alignItems: "baseline" }}>
        <TextField
          label="Add Email"
          variant="outlined"
          fullWidth
          //  size="small"
          value={inputValue}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          error={error}
          helperText={
            error ? "Enter a valid email" : "Press Enter to add email"
          }
        />
        {/* <Button
          type="submit"
          variant="contained"
          color="primary"
          onClick={isEmail ? handleSendMail : null}
          style={{
            backgroundColor: isEmail ? "#4f2d7f" : "grey",
            color: "white",
            textTransform: "capitalize",
            height: "32px",
            marginLeft: "1em",
            cursor: isEmail ? "pointer" : "not-allowed",
          }}
        >
          Send
          <SendIcon
            style={{ height: "15px", width: "15px", marginLeft: "0.2em" }}
          />
        </Button> */}
      </div>

      {emails?.length > 0 && (
        <List className={classes.emailList}>
          {emails.map((email, index) => (
            <ListItem key={index} className={classes.listItem} dense>
              <ListItemText primary={email} className={classes.listItemText} />
              <IconButton
                edge="end"
                onClick={() => handleDelete(email)}
                className={classes.iconButton}
              >
                <DeleteIcon />
              </IconButton>
            </ListItem>
          ))}
        </List>
      )}
    </div>
  );
};

export default EmailTextFeildMultiple;
